module.exports = __webpack_public_path__ + "img/jibie_top0_false.013636d4.png";